export default function () {
	return {
		activeTab: window.location.hash === '#register' ? 'register' : 'login',

		init() {
			this.attachEvents()
		},

		attachEvents() {
			window.addEventListener('hashchange', () => {
				this.activeTab = window.location.hash === '#register' ? 'register' : 'login'
			})
		},
	}
}
